import React from "react";
import PropTypes from "prop-types";
import { QuickNavigation } from "../components";
import { localStore } from "helpers";
import consts from "consts";
import { Alert } from "../../../../common/utils";
import APIManager from "modules/common/apiManager";
import { globalUrlList } from "../../../../../helpers/dotenv";
import { messageService } from "../../../../../dialpad/service";

const QuickNavigationContainer = (props) => {
  const { LOGIN_TOKEN_KEY, LOGIN_REFRESH_TOKEN_KEY } = consts;

  const mAPI = new APIManager();

  const getLocationCheck = (path) => {
    try {
      return window.location.pathname == path ? true : false;
    } catch (error) {
      return false;
    }
  }

  const logout = () => {
    // remove tokens
    if (globalUrlList.some((url) => getLocationCheck(url))) {
      mAPI.sendPostAPI(
        `auth/logout`,
        {
          // authorization: localStore.getItem("token"),
          everywhere: true
        },
        (data) => {
          let message = {
            type: "stateHandler",
            state: "offline",
            subState: "",
            stateInfo: "",
          };
          messageService.emitSocketMessage("message-processor", message);
          localStorage.removeItem(LOGIN_TOKEN_KEY);
          localStorage.removeItem(LOGIN_REFRESH_TOKEN_KEY);

          localStorage.removeItem("REACT_APP_API_SUBSCRIPTION_URL");
          localStorage.removeItem("REACT_APP_API_URL");
          localStorage.removeItem("REACT_FS_SERVER_HOST");
          localStorage.removeItem("USER_ID");

          // localStore.removeItem('selected-tenant');
          localStore.removeItem("token");
          localStore.removeItem("user");

          if (data && data.redirectUrl) {
            window.location.href = data.redirectUrl;
          } else {
            window.location.href = "/";
          }

          // window.location.href = "/";
        },
        (errorCode, data) => {
          Alert.error(`errorCode : ${data}`);
        },
        `public`,
        {},
        "DELETE"
      );
    } else {
      mAPI.sendPostAPI(
        `auth/logout`,
        {
          authorization: localStore.getItem("token"),
        },
        (data) => {
          let message = {
            type: "stateHandler",
            state: "offline",
            subState: "",
            stateInfo: "",
          };
          messageService.emitSocketMessage("message-processor", message);
          localStorage.removeItem(LOGIN_TOKEN_KEY);
          localStorage.removeItem(LOGIN_REFRESH_TOKEN_KEY);

          localStorage.removeItem("REACT_APP_API_SUBSCRIPTION_URL");
          localStorage.removeItem("REACT_APP_API_URL");
          localStorage.removeItem("REACT_FS_SERVER_HOST");
          localStorage.removeItem("USER_ID");

          // localStore.removeItem('selected-tenant');
          localStore.removeItem("token");
          localStore.removeItem("user");

          if (data && data.redirectUrl) {
            window.location.href = data.redirectUrl;
          } else {
            window.location.href = "/";
          }

          // window.location.href = "/";
        },
        (errorCode, data) => {
          Alert.error(`errorCode : ${data}`);
        },
        `private`,
        {},
        "DELETE"
      );
    }
  };

  const updatedProps = {
    ...props,
    logout,
  };

  return <QuickNavigation {...updatedProps} />;
};

QuickNavigationContainer.propTypes = {
  history: PropTypes.object,
};

export default QuickNavigationContainer;



// WEBPACK FOOTER //
// src/modules/theme/theme1/layout/containers/QuickNavigation.js